import moment from 'moment-timezone'

class CoreConfiguration {
  constructor () {
    this.factoryTimezone = null
  }

  setFactoryTimezone (tz) {
    this.factoryTimezone = tz
  }

  setMomentLocale (locale) {
    moment.locale(locale === 'zh' ? 'zh-cn' : locale)
  }
}

export default new CoreConfiguration()
